import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/age.png'

const DemographicsAge = dynamic(() => import('src/components/insights/demographics/cards/age'), {
  ssr: false,
})

export const DemographicsAgeWidget: InsightBuilderWidget = {
  id: 'age',
  name: 'Age',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsAge,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
